var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"goods",attrs:{"src":require("../../../../assets/image/live/goods.png")},on:{"click":_vm.showgoods}})}
var staticRenderFns = []

export { render, staticRenderFns }